import { render, staticRenderFns } from "./EditFund.vue?vue&type=template&id=3c1fae5e&scoped=true&"
import script from "./EditFund.vue?vue&type=script&lang=js&"
export * from "./EditFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1fae5e",
  null
  
)

export default component.exports